<app-basic-modal className="leaving">
    <h1>You are now leaving the Bayer Commercial Area<br> and entering Medical Information.</h1>

    <div class="answers">
        <div class="button blue" (click)="continue()">Continue</div>
        <div class="button white" (click)="goBack()">Go Back</div>
    </div>
</app-basic-modal>
